import Figure from "~/components/figure"
import fetchGradients from "~/components/circuit/fetchGradients"
import { Spinner } from "evergreen-ui"
import Tiles from "~/components/tiles"
import { scaleLinear } from "d3-scale"

export default class CurveTiles extends Component {
  state = { weights: null }

  componentWillMount() {
    fetchGradients("inceptionv1", "mixed3a", "mixed3b").then(weights => {
      this.setState({ weights })
    })
  }

  render() {
    const { weights } = this.state
    const { size = 60 } = this.props
    const scale = scaleLinear().domain([0, 40])

    if (!weights) {
      return <Spinner />
    }
    const upstream = [189, 81, 104, 92, 145, 95, 163, 71, 147]
    const neurons = [406, 385, 343, 342, 388, 324, 340, 330, 349, 379]

    return (
      <Surface
        display="grid"
        overflow="hidden"
        gridGap={1}
        gridTemplateRows={`repeat(${upstream.length + 1}, auto)`}
        gridTemplateColumns={`repeat(${neurons.length + 1}, auto)`}
        borderRadius={5}
        background="#EAEAEA"
        style={{ border: "1px solid rgba(0, 0, 0, 0.3)" }}
      >
        <Surface width={size} height={size} />
        {neurons.map(neuron => (
          <Surface width={size} height={size}>
            <img
              width={size}
              height={size}
              src={neuronFeatureVis("inceptionv1", "mixed3b", neuron)}
            />
          </Surface>
        ))}
        {upstream.map(upstreamNeuron => (
          <React.Fragment>
            <ZoomedImg
              size={size}
              padding={10}
              src={neuronFeatureVis("inceptionv1", "mixed3a", upstreamNeuron)}
              style={{ borderRadius: 0 }}
            />
            {neurons.map(neuron => (
              <Tiles
                size={size}
                grad={weights[upstreamNeuron][neuron]}
                hasBorder={false}
                scale={scale}
              />
            ))}
          </React.Fragment>
        ))}
      </Surface>
    )
  }
}
